export const NAME = "InvitationView"
export const FORM_NAME = `${NAME}/InvitationForm`
export const DELETE_FORM_NAME = `${NAME}/DeleteInvitationForm`
export const RESEND_FORM_NAME = `${NAME}/ResendInvitationForm`
